(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
      this.onResizeHandler = this.onResize.bind(this);
    }

    connectedCallback() {
      this.header = this.closest('.section-header') || document.querySelector('.section-header');
      if (!this.header) return;

      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate', 'scrolled-past-header');

      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.setHeaderHeight();
      this.refreshHeaderBounds();

      // Set header bottom position for mega menu max-height calculation on page load
      requestAnimationFrame(() => {
        const headerWrapper = document.querySelector('.header-wrapper');
        if (headerWrapper) {
          document.documentElement.style.setProperty(
            '--header-bottom-position-desktop',
            `${Math.floor(headerWrapper.getBoundingClientRect().bottom)}px`
          );
        }
      });

      this.lastWidth = window.innerWidth;
      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);
      window.addEventListener('resize', this.onResizeHandler);
      window.addEventListener('load', this.refreshHeaderBounds.bind(this), { once: true });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
    }

    setHeaderHeight() {
      if (this.header) {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }
      this.refreshHeaderBounds();
    }

    onResize() {
      // Mobilde kaydırırken adres çubuğu gizlenip görününce yalnızca yükseklik değişir ve 'resize' tetiklenir.
      // Başlık yüksekliği genişliğe bağlı olduğu için sadece genişlik değişince yeniden hesaplanır.
      const width = window.innerWidth;
      if (width === this.lastWidth) return;
      this.lastWidth = width;
      this.setHeaderHeight();
    }

    refreshHeaderBounds() {
      // Cache header bounds so onScroll (which fires many times per second,
      // especially during touch scrolling on mobile) never forces a layout
      // recalculation. Bounds only change on resize/orientation change or
      // when the header's own height changes, both handled above.
      this.cachedBounds = this.getHeaderBounds();
    }

    disconnectedCallback() {
      if (this.mobileMediaQuery) {
        this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      }
      window.removeEventListener('resize', this.onResizeHandler);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    getHeaderBounds() {
      let top = 0;
      let prevSibling = this.header ? this.header.previousElementSibling : null;
      while (prevSibling) {
        if (prevSibling.classList.contains('shopify-section-group-header-group') || prevSibling.classList.contains('shopify-section')) {
          top += prevSibling.offsetHeight || 0;
        }
        prevSibling = prevSibling.previousElementSibling;
      }
      const bottom = top + (this.header ? this.header.offsetHeight : 0);
      return { top, bottom };
    }

    isHeaderHidden() {
      return this.header.classList.contains('shopify-section-header-hidden');
    }

    isHeaderSticky() {
      return this.header.classList.contains('shopify-section-header-sticky');
    }

    isOverlayOpen() {
      if (this.header.querySelector('details-modal details[open], .header__search details[open], header-drawer details[open]')) return true;
      for (const predictiveSearch of this.predictiveSearches) {
        if (predictiveSearch.isOpen) return true;
      }
      return false;
    }

    isOverscrolled(scrollTop) {
      // iOS Safari'de sayfa sonunda esneme (bounce) sırasında scrollTop taşar; geri dönüş "yukarı kaydırma"
      // gibi görünüp başlığı yanlışlıkla gösterirdi.
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      return scrollTop > maxScroll + 1;
    }

    onScroll() {
      if (!this.header) return;
      if (document.body.classList.contains('scroll-locked') || document.documentElement.classList.contains('scroll-locked')) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;

      if (this.currentScrollTop === undefined) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (Math.abs(scrollTop - this.currentScrollTop) < 4) return;

      const bounds = this.cachedBounds || this.getHeaderBounds();

      // Ağır kontroller (querySelector vb.) her kaydırma olayında değil, yalnızca durum değişecekse yapılır.
      if (scrollTop > this.currentScrollTop && scrollTop > bounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventHide && !this.isHeaderHidden() && !this.isOverlayOpen()) {
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop < this.currentScrollTop && scrollTop > bounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          const needsReveal = this.isHeaderHidden() || !this.isHeaderSticky();
          if (needsReveal && !this.isOverlayOpen() && !this.isOverscrolled(scrollTop)) {
            requestAnimationFrame(this.reveal.bind(this));
          }
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          if (!this.preventHide && !this.isHeaderHidden() && !this.isOverlayOpen()) {
            requestAnimationFrame(this.hide.bind(this));
          }
        }
      } else if (scrollTop <= bounds.top) {
        this.header.classList.remove('scrolled-past-header');
        if (this.isHeaderSticky() || this.isHeaderHidden() || this.header.classList.contains('animate')) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky || this.isHeaderHidden()) return;
      if (this.header.querySelector('details-modal details[open], .header__search details[open]')) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      if (!this.isHeaderHidden() && this.isHeaderSticky()) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
